import React from 'react';
/**
 * `SinglePaymentDisplay` renders a single-payment pricing snippet.
 *
 * Behaviour:
 * - Displays an optional leading `text` (e.g. "or").
 * - Uses i18n for the "single payment" label.
 * - Formats the amount using the provided `culture` and current currency
 *   symbol.
 * - Applies the provided `style` class to the price span.
 */

import { formatNumber } from '../../../common/Formatter';
import { useCurrencySymbol } from '../../../../hooks/useCurrencySymbol';
import { useTranslation } from 'react-i18next';

type SinglePaymentDisplayProps = {
  style: string;
  text: string;
  priceSingle: number;
  culture: string;
};

const SinglePaymentDisplay = ({
  style,
  text,
  priceSingle,
  culture
}: SinglePaymentDisplayProps): JSX.Element => {
  const { t } = useTranslation();
  const currencySymbol = useCurrencySymbol();
  const singlePaymentText = t('renewals-quote.single-payment-text');
  return (
    <p>
      <span>{text}</span>
      <span>{singlePaymentText}</span>
      <span className={style}>
        {currencySymbol}
        {formatNumber(priceSingle, 2, culture)}
      </span>
    </p>
  );
};

export default SinglePaymentDisplay;
